import { PayloadAction } from "@reduxjs/toolkit";

import { THouseViewState, initialState } from ".";

export type SidebarCurrentAction = {
  inProgress: (typeof availableActions)[number] | null;
  isDirty?: boolean;
};

const availableActions = [
  "assignAttributes",
  "editShifts",
  "updateStatus",
  "findStaffToWork",
  "floating",
  "openShifts",
] as const;

const actionSliceKeyByAction: Record<
  NonNullable<SidebarCurrentAction["inProgress"]>,
  keyof THouseViewState
> = {
  assignAttributes: "assignAttributes",
  editShifts: "editShifts",
  findStaffToWork: "findStaffToWork",
  floating: "floating",
  updateStatus: "updateStatus",
  openShifts: "openShifts",
};

export const SidebarActions = {
  startAction: (
    { sidebarCurrentAction }: THouseViewState,
    action: PayloadAction<SidebarCurrentAction["inProgress"]>,
  ) => {
    sidebarCurrentAction.inProgress = action.payload;
  },

  endAction: (
    state: THouseViewState,
    { payload: withOpenShifts }: PayloadAction<boolean | undefined>,
  ) => {
    let result = { ...state };

    //If the current action is openShifts and withOpenShifts is true, then don't reset the sidebarCurrentAction
    result =
      result.sidebarCurrentAction.inProgress === "openShifts" && withOpenShifts
        ? result
        : { ...result, sidebarCurrentAction: initialState.sidebarCurrentAction };

    availableActions.forEach((action) => {
      const actionSliceKey = actionSliceKeyByAction[action];
      result = { ...result, [actionSliceKey]: initialState[actionSliceKey] };
    });

    return result;
  },

  setCurrentActionDirtiness: (
    { sidebarCurrentAction }: THouseViewState,
    action: PayloadAction<SidebarCurrentAction["isDirty"]>,
  ) => {
    sidebarCurrentAction.isDirty = action.payload;
  },
};
